import Cookies from 'js-cookie';
import 'lazysizes';
import { isOnPage } from './utils';

/* global IMask */

const { body } = document;

/**
 * Input mask
 */
Array.from(document.querySelectorAll('input[type="tel"]')).forEach((el) => {
  IMask(el, {
    mask: [
      {
        mask: '8 (000) 000-00-00',
      },
      {
        mask: '+{7} (000) 000-00-00',
      },
    ],
    lazy: true,
  });
});

/**
 * Lazyload
 */
document.addEventListener('lazybeforeunveil', (e) => {
  const bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = `url(${bg})`;
  }
});

/**
 * Modals
 */
$.fancybox.defaults.closeExisting = true;
$.fancybox.defaults.backFocus = false;
$.fancybox.defaults.autoFocus = false;
$.fancybox.defaults.touch = false;
$.fancybox.defaults.lang = 'ru';
$.fancybox.defaults.i18n = {
  ru: {
    CLOSE: 'Закрыть',
    NEXT: 'Следующий',
    PREV: 'Предыдущий',
    ERROR: 'Запрос не может быть обработан. <br/>Пожалуйста попробуйте еще раз позже.',
    PLAY_START: 'Запустить слайдшоу',
    PLAY_STOP: 'Остановить слайдшоу',
    FULL_SCREEN: 'На весь экран',
    THUMBS: 'Миниатюры',
    DOWNLOAD: 'Скачать',
    SHARE: 'Поделиться',
    ZOOM: 'Увеличить',
  },
};

if (isOnPage('#night-mode-toggle')) {
  const nightModeToggle = document.querySelector('#night-mode-toggle');

  nightModeToggle.addEventListener('click', () => {
    body.classList.toggle('theme--dark');

    if (Cookies.get('theme') === 'dark') {
      Cookies.set('theme', 'light');
    } else {
      Cookies.set('theme', 'dark');
    }
  });
}

/**
 * Header
 */
const header = document.querySelector('#main-header');

const checkScrollPos = () => {
  const scrollTop = window.scrollY;
  if (scrollTop <= 50) {
    header.classList.remove('header--fixed');
  } else {
    header.classList.add('header--fixed');
  }
};
checkScrollPos();

window.addEventListener('scroll', () => {
  requestAnimationFrame(checkScrollPos);
});

/**
 * Mobile nav
 */
const mobileNav = document.querySelector('#mobile-nav');
const mobileNavLinks = Array.from(mobileNav.querySelectorAll('a'));
const mobileNavToggle = document.querySelector('#mobile-nav-toggle');

const mobileNavHandler = () => {
  mobileNavToggle.classList.toggle('btn--active');
  mobileNav.classList.toggle('show');
};

mobileNavToggle.addEventListener('click', mobileNavHandler);
mobileNavLinks.forEach((link) => link.addEventListener('click', mobileNavHandler));

/**
 * Copy text
 */
const copyToClipboard = (button) => {
  const target = document.getElementById(button.dataset.target);
  target.focus();
  target.select();
  document.execCommand('copy');
  target.blur();
};

if (isOnPage('[data-copy-text]')) {
  Array.from(document.querySelectorAll('[data-copy-text]')).forEach((button) => {
    button.addEventListener('click', () => {
      copyToClipboard(button);
    });
  });
}

/**
 * Smooth scroll
 */
if (isOnPage('a[data-smooth-scroll]')) {
  Array.from(document.querySelectorAll('a[data-smooth-scroll]')).forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('href');

      $([document.documentElement, document.body]).animate({
        scrollTop: $(targetId).offset().top - 100,
      }, 1500);
    });
  });
}
